import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://hudhvleccnbaomvtuhwc.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1ZGh2bGVjY25iYW9tdnR1aHdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE2NDEzNDgsImV4cCI6MjA5NzIxNzM0OH0._gtccSqa3nVMvJqLQ4ZVS9KfCy86aOzRPqnx6iIFp3g';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
